module.exports = __webpack_public_path__ + "static/media/yellow-flag.03d0035f.svg";